<i class="color-success clickable far fa-download" aria-hidden="true"
   (click)="onDownload()"
   title="Export table content as XLSX"
   i18n-title="@@collection.export.content.icon"></i>
